export default __webpack_public_path__ + "static/media/10 FIREARMS.4ca65cf6.png";